import React from "react";
import EmptyState from "@/components/EmptyState";

function NoHeroImage() {
  return <EmptyState Icon={null} title="" message="No hero images found" />;
}

export default NoHeroImage;
